export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_5-edee85292414b1731c2f5a093d049194.svg";